import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
import CopyBox from '../components/bbcode/copy-box';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

export default class DJAreaConnection extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			mode: 0,
      icecast: {},
			icecast_test: {},
			rtmp: {},
			source: 'https://cloud.mix365.co.uk:4434/test/mix365radio/index.m3u8',
			shoutcast: {connected_butt: false, connected_obs: false, connected_rtmp: false, connected_azura: false, dj: '', artist: '', title: '',},
			videobitrate: {connected_rtmp: false, connected_test: false, path: '', width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0},
			resetvideo: false,
			HeaderShoutcast: null,
			VideoRate: null,
			changekey: false,
		};
		this.changeMode = this.changeMode.bind(this);
		this.onReady = this.onReady.bind(this);
		this.onError = this.onError.bind(this);
		this.reloadPlayer = this.reloadPlayer.bind(this);
		this.changekey = this.changekey.bind(this);
  };

  async componentDidMount() {
		document.title = "Admin - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		var params = new URLSearchParams();
		const x = await postApi('/api/v2/djarea/connection', params);
		this.setState({mode: x.data.mode, icecast: x.data.icecast, icecast_test: x.data.icecast_test, rtmp: x.data.rtmp});

		EventEmitter.emit('/header/shoutcast/request', {});

		const HeaderShoutcast = EventEmitter.addListener('/header/shoutcast', async data => {
			//this.renderLiveFeed( data );
			this.setState({shoutcast: data.cast});
		}); this.setState({HeaderShoutcast});

		//---- VideoRate
		const VideoRate = EventEmitter.addListener('/chatlive/videorate', async data => {
			//data.connected_test = true;
			
			console.log(data);
				this.setState({videobitrate: data});
			
		}); this.setState({VideoRate});
	}

	componentWillUnmount() {
		if( this.state.HeaderShoutcast ) this.state.HeaderShoutcast.remove();
		if( this.state.VideoRate ) this.state.VideoRate.remove();
	}


	async changeMode(mode) {
		if( window.confirm("Are you sure you wish to change mode?") ) {
			var params = new URLSearchParams();
			params.append('mode', mode)
			await postApi('/api/v2/djarea/connection/mode', params);
			this.setState({mode});
		}
	}

	onReady(event) {
		const player = window.jwplayer(this.playerId);
		//console.log(player);
		player.play();
	}

	onError(event) {
		let x = this.state.videobitrate;
		x.connected_test = false;
		this.setState({videobitrate: x}, () => {
			x.connected_test = true;
			this.setState({videobitrate: x});
		})
	}

	async changekey() {
		if( window.confirm("Are you sure you wish to change your password? Please ensure to change it after your password has been changed.") ) {
			this.setState({changekey: true});
			var params = new URLSearchParams();
			await putApi('/api/v2/djarea/connection/password', params);
			var params2 = new URLSearchParams();
			const y = await postApi('/api/v2/djarea/connection', params2);
			this.setState({mode: y.data.mode, icecast: y.data.icecast, icecast_test: y.data.icecast_test, rtmp: y.data.rtmp, changekey: false});
		}
	}

	reloadPlayer() {
		if( this.state.resetvideo ) return;
		this.setState({resetvideo: true}, ()=>{
			setTimeout(()=>{
				if( this.state.videobitrate.select===3 ) return;
				let select = this.state.videobitrate;
				select.connected_test = false;
				this.setState({videobitrate: select, resetvideo: false}, ()=> {
					select.connected_test = true;
					this.setState({videobitrate: select,});
				});
			},4000);
		});
	}

	render() {
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					<Row>
						<div className="col-6 text-center">
							<Card style={{width: '18rem', backgroundColor: 'rgba(0,0,0,0.4)', margin: 'auto'}}>
								<Card.Img variant="top" src="/images/Azuracast-400x284.png" />
								<Card.Body>
									<Card.Title className="text-center">Audio Mode</Card.Title>
									<Card.Text>
										
											You provide only the Audio feed<br />
											<br />
										
									</Card.Text>
									{this.state.mode === 1?
										<Button variant="primary" disabled>Selected</Button>
									:
										<Button variant="primary" onClick={()=>this.changeMode(1)}>Switch to Audio Mode</Button>
									}
								</Card.Body>
							</Card>
						</div>
						<div className="col-6 text-center">
							<Card style={{width: '18rem', backgroundColor: 'rgba(0,0,0,0.4)', margin: 'auto'}}>
								<Card.Img variant="top" src="/images/obs_studios.jpg" style={{padding: '0 20'}} />
								<Card.Body>
									<Card.Title>Video Mode</Card.Title>
									<Card.Text>
										
											You provide both the Audio<br />
											and Video feed<br />
										
									</Card.Text>
									{this.state.mode === 2?
										<Button variant="primary" disabled>Selected</Button>
									:
										<Button variant="primary" onClick={()=>this.changeMode(2)}>Switch to Video Mode</Button>
									}
								</Card.Body>
							</Card>
						</div>

					</Row>

					{this.state.mode===1&&
						<Row>
							<Col xs={12} className="pt-5">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">IceCast / Audio Connection Details</h3>
										<div className="card-tools">
											<span className="badge">
												<Button size="sm" onClick={this.changekey} disabled={this.state.changekey}>
													{this.state.changekey?'Please wait':'Change Stream Key'}
												</Button>
											</span>
										</div>
									</div>
									<div className="card-body">
										Our Icecast server connection details:<br /><br />
										
										Use either of the following server addresses:<br />
										<Row>
											<Col xs={2}>
												<CopyBox content={this.state.icecast.address} />
											</Col>
											<Col xs={2}>
												<CopyBox content={this.state.icecast.ip} />
											</Col>
										</Row>

										Type:<br />
										<Row>
											<div className="col-md-4">
												<div className="code-box">
													{this.state.icecast.type}
												</div>
											</div>
										</Row>

										We have multiple channels and esure you are connecting to the correct port:<br />
										<Row>
											<Col xs={2}>
												Hyper Port:<br />
												<CopyBox content={this.state.icecast.port_clubbers} />
											</Col>
											<Col xs={2}>
												Evolution Port:<br />
												<CopyBox content={this.state.icecast.port_radio} />
											</Col>
										</Row>

										Username:<br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.icecast.username} />
											</div>
										</Row>

										Password:<br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.icecast.password} />
											</div>
										</Row>

										Mount Point:<br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.icecast.mount} />
											</div>
										</Row>

										Audio Bitrate:<br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.icecast.rate+' kbps'} />
											</div>
										</Row>

									</div>
									<div className="card-footer">
										To test your audio stream head over to our <Link to='/djarea/test'>test station</Link>
									</div>
								</div>
							</Col>
							
							<Col xs={12} className="pt-5">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">IceCast / Audio Connection Guide</h3>
									</div>
									<div className="card-body">

										Available platforms that support streaming to Icecast:<br />
										<div className="row">
											<div className="col text-center">
												<a href="https://mixxx.org/download/" target="_blank" rel="noreferrer" ><img src="/images/Mixxx-Logo.wine.png" height="160" alt="Mixxx Logo" /><br />Mixxx</a>
											</div>
											<div className="col text-center">
												<a href="https://spacial.com/sam-cast/" target="_blank" rel="noreferrer" ><img src="/images/sam-cast_119600-1987006601.jpg" height="160" alt="Sam Cast Logo" /><br />Sam Cast</a>
											</div>
											<div className="col text-center">
												<a href="https://www.djsoft.net/" target="_blank" rel="noreferrer" ><img src="/images/th-4024695146.jpg" height="160" alt="RadioBoss Logo" /><br />RadioBoss</a>
											</div>
											{/*<div className="col text-center">
												<a href="https://www.native-instruments.com/en/catalog/traktor/" target="_blank" rel="noreferrer" ><img src="/images/traktor-pro-2-logo-229146-1158276047.jpg" height="160" /><br />Traktor</a>
											</div>*/}

										</div><br /><br />
										
										If your mixing software does not support or provide streaming to our Icecast server, download and install BUTT Broadcaster:<br />
										<div className="row">
											<div className="col-12 col-sm-4 text-center">
												<a href="https://danielnoethen.de/butt/" target="_blank" rel="noreferrer" ><img src="/images/butt-logo.png" height="140" alt="Download Butt" /><br />Download Butt</a>
											</div>
										</div>
										
										<br /><br />

										<span style={{fontWeight: 600, fontSize: 18}}>Setup Guide</span><br /><br />
										You may use your own software of choice to stream to our platform and our examples are setting up streaming with BUTT broadcaster<br />
										From your mixing software or Butt broadcaster software, Click on the `settings` button to get started, and it will load the Settings window:<br /><br />
										<img src="/images/docs/butt2.png" height="300" style={{paddingLeft:100}} alt="Butt 2" /><br /><br />

										On the `Main` option in settings select `add` and refer to streaming settings below<br /><br />
										<img src="/images/docs/butt3.png" height="400" style={{paddingLeft:100}} alt="Butt 3" /><br /><br />
										
										
										<span style={{fontWeight: 600, fontSize: 18}}>Configuring Audio</span><br /><br />
										On the settings menu go to `Audio`, BUTT provides support for a number of audio input types. If you have multiple sound devices you may also select which one to use. Butt default settings would be the best preference, such as `Microsoft Sound Mapper` or `Default PCM Device`<br /><br />
										<img src="/images/docs/butt4.png" height="400" style={{paddingLeft:100}} alt="Butt 4" /><br /><br />
										
										Streaming Audio Bitrate: {this.state.icecast.rate}k<br /><br />

										<span style={{fontWeight: 600, fontSize: 18}}>Complete</span><br /><br />
										<img src="/images/docs/butt5.png" height="200" style={{paddingLeft:100}} alt="Butt 5" /><br /><br />

										You can adjust the slider bar underneath the audio bars - in the yellow is fine - please stay out of the red as it will distort. This is you main audio output level onto our system<br />
										Once you are happy with everything, ensure there are no DJ's live and simply hit the play button. It will connect up and you will be LIVE streaming, to finish simply hit the stop button.<br /><br />
										

									</div>
								</div>
							</Col>

							<div className="row mt-5 admin-panel">
								<div className="col-12 admin-panel-header">
									
								</div>
								<div className="col-12 admin-panel-body">

									
									
								</div>
							</div>
						</Row>
					}

					{this.state.mode===2&&
						<Row>
							<Col xs={12} className="pt-5">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS / Video Connection Details</h3>
										<div className="card-tools">
											<span className="badge">
												<Button size="sm" onClick={this.changekey} disabled={this.state.changekey}>
													{this.state.changekey?'Please wait':'Change Stream Key'}
												</Button>
											</span>
										</div>
									</div>
									<div className="card-body">
										The connection details are the same for both the hyper and evolution channels and to connect to our RTMP live server:<br /><br />

										Europe Server Address:<br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.rtmp.address} />
											</div>
										</Row>

										Non Europe Server Address:<br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.rtmp.address_cdn} />
											</div>
										</Row>
										

										Stream Key: <br />
										<Row>
											<div className="col-md-4">
												<CopyBox content={this.state.rtmp.streamkey} />
											</div>
										</Row>
										

										<br />Maximium settings:<br />
										<Row>
											<div className="col-md-4">
												<div className="code-box ">
													Resolution: 1920 x 1080<br />
													FPS: 30<br />
													Audio Bitrate: {this.state.icecast.rate} kbps<br />
												</div>
											</div>
										</Row>
									</div>
									<div className="card-footer">
										To gather the correct video bitrate for your stream, head over to our <Link to='/djarea/test'>test station</Link> and this will test your stream and provide you with the bitrate to use
									</div>
								</div>
							</Col>

							<Col xs={12} className="pt-5">
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS / Video Connection Guide</h3>
									</div>
									<div className="card-body">
										<div className="row">
											<div className="col-12 col-sm-4 text-center">
												<a href="https://obsproject.com/" target="_blank" rel="noreferrer" ><img src="/images/obs_studios.jpg" height="150" alt="obs-studios" /><br />Download OBS</a>
											</div>
										</div><br />

										You can download OBS Studio from <a href="https://obsproject.com/" target="_blank" rel="noreferrer" >https://obsproject.com</a> Make sure that you download the correct version depending on whether you're using Windows, a Mac or Linux.<br />
										Once downloaded, follow the installation steps and open up OBS Studio on your computer. It should look like this:<br /><br />
										
										<img src="/images/docs/obs1.png" height="200" style={{paddingLeft:100}} alt="OBS 1" /><br /><br />
										
										<span style={{fontWeight: 600, fontSize: 18}}>How do I create a Scene?</span><br /><br />
										The first step to setting up OBS Studio for Mix365 Live is to create a Scene. This is what you’ll be showing to your audience and includes the audio, visuals and anything else you want to add which are called Sources.<br />
										A Scene should be automatically created for you, but if not you can add one by clicking the plus button at the bottom of the Scenes box.<br />
										You can also name them so you may want to call it something like My Mix365 Live Stream.<br /><br />
										<img src="/images/docs/obs2.png" height="200" style={{paddingLeft:100}} alt="OBS 2" /><br /><br />


										<span style={{fontWeight: 600, fontSize: 18}}>How do I add Sources?</span><br /><br />
										<span style={{fontWeight: 400, fontSize: 16}}>Audio</span><br />
										First, you’ll want to add audio to your Scene so people can hear your show. To do this go to Sources and choose Audio Input Capture. This is an input from your equipment.<br />
										<img src="/images/docs/obs3.png" height="200" style={{paddingLeft:100}} alt="OBS 3" /><br /><br />

										Then name the source and click OK. OBS will then give you the option of what input you'd like to have for this source from those available on your computer.<br />
										<img src="/images/docs/obs4.png" height="200" style={{paddingLeft:100}} alt="OBS 4" /><br /><br />

										Click OK and you now have an audio source for your stream.<br /><br />

										<span style={{fontWeight: 400, fontSize: 16}}>Video</span><br />
										To add visuals to your stream, you'll need to add another input as with the audio.<br />
										To do this go to Sources and choose Video Capture Device.<br />
										<img src="/images/docs/obs5.png" height="200" style={{paddingLeft:100}} alt="OBS 5" /><br /><br />

										Then name the source and click OK. OBS will then give you the option of what input you'd like to have for this source from those available on your computer.<br />
										<img src="/images/docs/obs6.png" height="200" style={{paddingLeft:100}} alt="OBS 6" /><br /><br />

										Click OK and you now have a video source for your stream. You may want to resize the source to be the same size as the black square.<br /><br />

										<span style={{fontWeight: 400, fontSize: 16}}>Logo</span><br />
										You may also want to add a logo or image alongside/rather than the video.<br />
										To do this easily go to Sources and choose Image.<br />
										<img src="/images/docs/obs7.png" height="200" style={{paddingLeft:100}} alt="OBS 7" /><br /><br />

										Then name the source and Click OK. OBS will give you the option of what image you'd like to have for this source from those available on your computer.<br />
										Click OK and you now have an image that can be resized and positioned how you want.<br /><br />


										<span style={{fontWeight: 600, fontSize: 18}}>OBS Streaming Settings</span><br /><br />

										Our system is centralised and runs from the cloud. When using the settings below this connects to OUR system and not direct to source i.e Our Website, Mixcloud or twitch ect. It's a fully automated system and in the event of this not working please report this straight away.<br /><br />

										<span style={{fontWeight: 400, fontSize: 16}}>What settings do I need to connect to Mix365 Live?</span><br />
										With your stream sources set up, you'll want to make sure the settings are correct for streaming on Mix365 Live. To do this, go to the Settings tab on OBS Studio and select Stream.<br />
										<img src="/images/docs/obs8.png" height="200" style={{paddingLeft:100}} alt="OBS 8" /><br /><br />

										The settings you'll want for Mix365 Live are as follows:<br />
										Service - Custom<br />
										Server - {this.state.rtmp.address}<br />
										Stream Key - {this.state.rtmp.streamkey}<br /><br />
										We would recommend not changing any of your audio or video settings from the default on your streaming software the first time you stream. Changing the settings can result in the connection not working correctly.<br /><br />


										<span style={{fontWeight: 400, fontSize: 16}}>Whats Next</span><br /><br />
										Now your stream and settings are set up and connected to Mix365 Live all you need to do is click the Start Streaming button on your streaming software.<br /><br />
										<span style={{fontWeight: 400, fontSize: 16}}>How do I ensure I have the optimal settings for streaming?</span><br /><br />
										Video resolution - we recommend a video resolution of 720p and a visual ratio of 16:9 (1280x720)<br />
										<img src="/images/docs/obs9.png" height="200" style={{paddingLeft:100}} alt="OBS 9" /><br /><br />

										Video bitrate - we recommend setting video bitrate to between 2500kbps to 3500kbps and using CBR not VBR<br /><br />

										Audio bitrate - we recommend setting audio bitrate to 320kbps. As a music-focused streaming platform, we want your viewers to experience the best possible sound quality.<br />
										<img src="/images/docs/obs10.png" height="200" style={{paddingLeft:100}} alt="OBS 10" /><br /><br />
									</div>
									
								</div>
							</Col>
						</Row>
					}
				</Col>
			</Row>
		);
	}
}
